import React from 'react';
import { Tag, Text } from 'src/@vymo/ui/atoms';
import { getModificationTag } from 'src/@vymo/ui/components/history/queries';
import { Keys, locale } from 'src/i18n';
import styles from './index.module.scss';

export default function SupervisorReviewHeader({ review }) {
  const { date, disposition } = review;

  return (
    <div className={styles.supervisorReview__header}>
      <div className={styles.supervisorReview__header__row}>
        <div className={styles.supervisorReview__header__row__titleRow}>
          <span className={styles.supervisorReview__header__title}>
            {locale(Keys.SUPERVISOR_REVIEW)}
          </span>
          {Boolean(date) && (
            <Text
              type="sublabel"
              classNames={styles.supervisorReview__header__subTitle}
            >
              {date}
            </Text>
          )}
        </div>
        {Boolean(disposition) && (
          <Tag bold variant="default" label={disposition} />
        )}
        <span className={styles.supervisorReview__header__tag}>
          {getModificationTag('vymo')}
        </span>
      </div>
    </div>
  );
}
